import _extends from 'babel-runtime/helpers/extends';
export var SET_STEP_STATUS_CONTEXT = 'SET_STEP_STATUS_CONTEXT';
export var PROGRESS_READY_FOR_COURSE = 'PROGRESS_READY_FOR_COURSE';
export var COURSE_VIEWED = 'COURSE_VIEWED';
export var COURSE_BEING_ASSIGNED = 'COURSE_BEING_ASSIGNED';
export var COURSE_ASSIGNED = 'COURSE_ASSIGNED';
export var SEQUENCE_VIEWED = 'SEQUENCE_VIEWED';
export var ACTIVITY_STEP_REVIEW = 'ACTIVITY_STEP_REVIEW';
var ACTIVITY_STEP_READY_FOR_CLOSE = 'ACTIVITY_STEP_READY_FOR_CLOSE';
export var ACTIVITY_STEP_TRY_AGAIN_SELECTED = 'ACTIVITY_STEP_TRY_AGAIN_SELECTED';
export var ACTIVITY_STEP_DISMISSED = 'ACTIVITY_STEP_DISMISSED';
export var ACTIVITY_STEP_MEDIA_STARTED = 'ACTIVITY_STEP_MEDIA_STARTED';
export var ACTIVITY_STEP_MEDIA_PAUSED = 'ACTIVITY_STEP_MEDIA_PAUSED';
export var ACTIVITY_STEP_MEDIA_FINISHED = 'ACTIVITY_STEP_MEDIA_FINISHED';
export var ACTIVITY_STEP_UPLOAD_STARTED = 'ACTIVITY_STEP_UPLOAD_STARTED';
export var ACTIVITY_STEP_UPLOAD_FINISHED = 'ACTIVITY_STEP_UPLOAD_FINISHED';
export var ACTIVITY_STEP_UPLOAD_FAILED = 'ACTIVITY_STEP_UPLOAD_FAILED';
export var START_ACTIVITY_STEP = 'START_ACTIVITY_STEP';
export var UPDATE_STEP_STATUS = 'UPDATE_STEP_STATUS';
export var PRONUNCIATION_ITEM_ATTEMPTED = 'PRONUNCIATION_ITEM_ATTEMPTED';
export var GO_TO_NEXT_PRONUNCIATION_ITEM = 'GO_TO_NEXT_PRONUNCIATION_ITEM';
export var SUBMIT_ACTIVITY_STEP = 'SUBMIT_ACTIVITY_STEP';
export var COMPLETE_ACTIVITY_STEP_ON_DISMISS_PAYLOAD = 'COMPLETE_ACTIVITY_STEP_ON_DISMISS_PAYLOAD';
export var SKIP_ACTIVITY_STEP = 'SKIP_ACTIVITY_STEP';
export var ACTIVITY_STEP_MIC_QUALITY_STR = 'ACTIVITY_STEP_MIC_CALIBRATION_DETAILS';
export var ACTIVITY_STEP_MIC_CALIBRATION_ERROR = 'ACTIVITY_STEP_MIC_CALIBRATION_ERROR';
export var LEARNING_ACTIVITY_INTERRUPTED = 'LEARNING_ACTIVITY_INTERRUPTED';
export var LEARNING_ACTIVITY_RESUMED = 'LEARNING_ACTIVITY_RESUMED';

//TODO: Is 20 minutes correct? What about extended writting?
// 20 minute max span to prevent weird things (like daylight savings switchover)
//const MAX_TIME_SPAN = 1000 * 60 * 20;
// const getElapsedSinceStart = (startTime, currentTime) => {
//   if (!startTime) {
//     return 0;
//   }
//   const elapsed = currentTime - startTime;
//   if (elapsed < 0) {
//     return 0;
//   }
//   if (elapsed > MAX_TIME_SPAN) {
//     return 0;
//   }
//   return elapsed;
// };

export var stepStatusReducer = function stepStatusReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];


  // logger.info('Paul - Reducer Action:', action);
  // logger.info('Paul - Payload:', action.payload);

  switch (action.type) {
    case PROGRESS_READY_FOR_COURSE:
      {
        return _extends({}, state, { progressReadyForCourseId: action.payload.courseId });
      }
    case COURSE_BEING_ASSIGNED:
      {
        return _extends({}, state, { courseBeingAssignedId: action.payload.courseId });
      }
    case START_ACTIVITY_STEP:
      {
        return _extends({
          stepStatusContext: state.stepStatusContext,
          installedProgressListeners: state.installedProgressListeners,
          progressReadyForCourseId: state.progressReadyForCourseId,
          activityStepReadyForClose: state.activityStepReadyForClose,
          courseBeingAssignedId: state.courseBeingAssignedId
        }, action.payload);
      }
    case SET_STEP_STATUS_CONTEXT:
      {
        return _extends({}, state, { stepStatusContext: action.payload });
      }
    case COMPLETE_ACTIVITY_STEP_ON_DISMISS_PAYLOAD:
      {
        return _extends({}, state, { completeActivityStepOnDismissPayload: action.payload.completeActivityStepOnDismissPayload });
      }
    case ACTIVITY_STEP_READY_FOR_CLOSE:
      {
        return _extends({}, state, { activityStepReadyForClose: action.payload.activityStepReadyForClose });
      }
    // Different action types are used for different side effects
    case SKIP_ACTIVITY_STEP:
    case SUBMIT_ACTIVITY_STEP:
    case UPDATE_STEP_STATUS:
      {
        return _extends({}, state, action.payload);
      }
    case ACTIVITY_STEP_UPLOAD_STARTED:
      {
        return _extends({}, state, { stepUploadInProgress: true });
      }
    case ACTIVITY_STEP_UPLOAD_FINISHED:
    case ACTIVITY_STEP_UPLOAD_FAILED:
      {
        return _extends({}, state, { stepUploadInProgress: false });
      }
    case ACTIVITY_STEP_MIC_QUALITY_STR:
      {
        return _extends({}, state, { micQualityStr: action.payload.micQualityStr });
      }
    case ACTIVITY_STEP_MIC_CALIBRATION_ERROR:
      {
        return _extends({}, state, { micCalibrationError: action.payload.micCalibrationError });
      }
    default:
      return state;
  }
};

export var stepStatusActions = {
  progressReadyForCourse: function progressReadyForCourse(courseId) {
    return {
      type: PROGRESS_READY_FOR_COURSE,
      payload: {
        courseId: courseId
      }
    };
  },
  setCourseBeingAssignedId: function setCourseBeingAssignedId(courseId) {
    return {
      type: COURSE_BEING_ASSIGNED,
      payload: {
        courseId: courseId
      }
    };
  },
  courseViewed: function courseViewed(courseId) {
    return {
      type: COURSE_VIEWED,
      payload: {
        courseId: courseId
      }
    };
  },
  courseAssigned: function courseAssigned(courseId) {
    return {
      type: COURSE_ASSIGNED,
      payload: {
        courseId: courseId
      }
    };
  },
  sequenceViewed: function sequenceViewed(courseId, sequenceId, sequenceVersion) {
    return {
      type: SEQUENCE_VIEWED,
      payload: {
        courseId: courseId,
        sequenceId: sequenceId,
        sequenceVersion: sequenceVersion
      }
    };
  },
  activityStepReview: function activityStepReview() {
    return {
      type: ACTIVITY_STEP_REVIEW
    };
  },
  activityStepTryAgainSelected: function activityStepTryAgainSelected() {
    return {
      type: ACTIVITY_STEP_TRY_AGAIN_SELECTED
    };
  },
  activityStepDismissed: function activityStepDismissed() {
    return {
      type: ACTIVITY_STEP_DISMISSED
    };
  },
  activityStepMediaStarted: function activityStepMediaStarted(mediaDurationMs, currentPlaybackTimeMs) {
    return {
      type: ACTIVITY_STEP_MEDIA_STARTED,
      payload: {
        mediaDurationMs: mediaDurationMs,
        currentPlaybackTimeMs: currentPlaybackTimeMs
      }
    };
  },
  activityStepMediaPaused: function activityStepMediaPaused(currentPlaybackTimeMs) {
    return {
      type: ACTIVITY_STEP_MEDIA_PAUSED,
      payload: { currentPlaybackTimeMs: currentPlaybackTimeMs }
    };
  },
  setActivityStepReadyForClose: function setActivityStepReadyForClose(activityStepReadyForClose) {
    return {
      type: ACTIVITY_STEP_READY_FOR_CLOSE,
      payload: { activityStepReadyForClose: activityStepReadyForClose }
    };
  },
  activityStepMediaFinished: function activityStepMediaFinished() {
    return {
      type: ACTIVITY_STEP_MEDIA_FINISHED
    };
  },
  activityStepUploadStarted: function activityStepUploadStarted() {
    return {
      type: ACTIVITY_STEP_UPLOAD_STARTED
    };
  },
  activityStepUploadFinished: function activityStepUploadFinished() {
    return {
      type: ACTIVITY_STEP_UPLOAD_FINISHED
    };
  },
  activityStepUploadFailed: function activityStepUploadFailed() {
    return {
      type: ACTIVITY_STEP_UPLOAD_FAILED
    };
  },
  setStepStatusContext: function setStepStatusContext(payload) {
    return {
      type: SET_STEP_STATUS_CONTEXT,
      payload: payload
    };
  },
  setMicQualityStr: function setMicQualityStr(micQualityStr) {
    return {
      type: ACTIVITY_STEP_MIC_QUALITY_STR,
      payload: { micQualityStr: micQualityStr }
    };
  },
  setMicCalibrationError: function setMicCalibrationError(micCalibrationError) {
    return {
      type: ACTIVITY_STEP_MIC_CALIBRATION_ERROR,
      payload: { micCalibrationError: micCalibrationError }
    };
  },
  learningActivityInterrupted: function learningActivityInterrupted() {
    return {
      type: LEARNING_ACTIVITY_INTERRUPTED
    };
  },
  learningActivityResumed: function learningActivityResumed() {
    return {
      type: LEARNING_ACTIVITY_RESUMED
    };
  },
  startActivityStep: function startActivityStep(payload) {
    return {
      type: START_ACTIVITY_STEP,
      payload: payload
    };
  },
  updateStepStatus: function updateStepStatus(payload) {
    return {
      type: UPDATE_STEP_STATUS,
      payload: payload
    };
  },
  pronunciationItemAttempted: function pronunciationItemAttempted(correct) {
    return {
      type: PRONUNCIATION_ITEM_ATTEMPTED,
      payload: { correct: correct }
    };
  },
  goToNextPronunciationItem: function goToNextPronunciationItem(nextItemId) {
    return {
      type: GO_TO_NEXT_PRONUNCIATION_ITEM,
      payload: { nextItemId: nextItemId }
    };
  },
  submitActivityStep: function submitActivityStep() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      type: SUBMIT_ACTIVITY_STEP,
      payload: payload
    };
  },
  skipActivityStep: function skipActivityStep() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      type: SKIP_ACTIVITY_STEP,
      payload: payload
    };
  },
  setCompleteActivityStepOnDismissPayload: function setCompleteActivityStepOnDismissPayload(completeActivityStepOnDismissPayload) {
    return {
      type: COMPLETE_ACTIVITY_STEP_ON_DISMISS_PAYLOAD,
      payload: { completeActivityStepOnDismissPayload: completeActivityStepOnDismissPayload }
    };
  }
};

export var stepStatusSelectors = {
  getStepStatusContext: function getStepStatusContext(state) {
    return state.stepStatus.stepStatusContext;
  },
  getProgressReadyForCourseId: function getProgressReadyForCourseId(state) {
    return state.stepStatus.progressReadyForCourseId;
  },
  getCourseBeingAssignedId: function getCourseBeingAssignedId(state) {
    return state.stepStatus.courseBeingAssignedId;
  },
  getStepUploadInProgress: function getStepUploadInProgress(state) {
    return state.stepStatus.stepUploadInProgress;
  },
  getMicQualityStr: function getMicQualityStr(state) {
    return state.stepStatus.micQualityStr;
  },
  getMicCalibrationError: function getMicCalibrationError(state) {
    return state.stepStatus.micCalibrationError;
  },
  getActivityStepReadyForClose: function getActivityStepReadyForClose(state) {
    return state.stepStatus.activityStepReadyForClose;
  },
  getCompleteActivityStepOnDismissPayload: function getCompleteActivityStepOnDismissPayload(state) {
    return state.stepStatus.completeActivityStepOnDismissPayload;
  }
};